export default [
    {
        path: '/main/commandtypes',
        meta: {
            tag: 'list_commandtype',
            name: 'Tipos de Comando',
            breadcrumb: 'Tipos de Comando'
        },
        component: () => import(/* webpackChunkName: "commandtype-list" */ '@/views/main/settings/parameters/commandTypes/Index.vue'),
        children: [
            {
            path: '',
            name: 'listcommandtypes',
            meta: {
                tag: 'list_commandtype',
                menu: 'settings',
                name: 'Tipos de Comando',
            },
            component: () => import(/* webpackChunkName: "commandtype-list" */ '@/views/main/settings/parameters/commandTypes/List.vue')
            },
            {
            path: '/main/commandtype/add',
            name: 'addcommandtype',
            meta: {
                tag: 'add_commandtype',
                menu: 'settings',
                name: 'Adicionar | Tipo de Comando',
                breadcrumb: 'Adicionar Tipo de Comando'
            },
            component: () => import(/* webpackChunkName: "commandtype-add" */ '@/views/main/settings/parameters/commandTypes/Add.vue')
            },
            {
            path: '/main/commandtype/:id',
            name: 'editcommandtype',
            meta: {
                tag: 'edit_commandtype',
                menu: 'settings',
                name: 'Editar | Tipo de Comando',
                breadcrumb: 'Editar Tipo de Comando'
            },
            component: () => import(/* webpackChunkName: "commandtype-edit" */ '@/views/main/settings/parameters/commandTypes/Edit.vue')
            }
        ]
    }
]  